<template>
    <b-autocomplete v-bind="$props"
                    v-model="lazyValue"
                    clearable
                    autocomplete="off"
                    v-on="$listeners"
                    data-lpignore="true"
                    :loading="loading"
                    :search-input.sync="searchValue"
                    :disabled="loading || disabled"
                    :items="items">
        <template v-slot:selection="{ item }">
            <Flag :code="item.code" class="mr-2" />
            {{ item.text }}
            <v-icon v-if="!item.active && showActiveFirst" small right>mdi-eye-off</v-icon>
        </template>
        <template v-slot:item="{ item, attrs, on }">
            <v-list-item v-on="on" v-bind="attrs">
                <v-list-item-content>
                    <v-list-item-title>
                        <v-row no-gutters align="center">
                            <Flag :code="item.code" class="mr-2" />
                            <span>{{ item.text }}</span>
                            <v-icon v-if="!item.active && showActiveFirst" small right>mdi-eye-off</v-icon>
                        </v-row>
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
    </b-autocomplete>
</template>

<script>
import Country from "@/models/Country/Country";
import AbstractPrefilledAutocomplete from "@/components/General/Form/Select/Abstract/AbstractPrefilledAutocomplete";
import Flag from "@/components/General/Icon/Flag";
import orderBy from "lodash/orderBy";

export default {
    components: {Flag},
    extends: AbstractPrefilledAutocomplete,
    props: {
        placeholder: {
            default: 'Zoek op naam of code',
        },
        showOnlyActive: {
            required: false,
            type: Boolean,
            default: false,
        },
        showActiveFirst: {
            required: false,
            type: Boolean,
            default: false,
        },
        append: {
            required: false,
            type: Function,
            default: null,
        },
        with: {
            required: false,
            type: Array,
            default: null,
        }
    },
    data() {
        return {
            model: Country,
            searchValue: '',
        }
    },
    computed: {
        items() {
            const entries = this.entries.map(entry => {
                return {
                    value: entry.id,
                    text: entry.label + ' (' + entry.code + ')' + (this.append ? ' ' + this.append(entry) : ''),
                    code: entry.code,
                    active: entry.is_active,
                }
            });

            if (this.searchValue?.length === 2) {
                return orderBy(entries, entry => {
                    return entry.code.toLowerCase() === this.searchValue.toLowerCase() ? 0 : 1;
                });
            }

            return entries;
        },
    },
    methods: {
        getAllEntries() {
            let query = Country.api();

            if (this.with) {
                query.with(this.with);
            }

            if (this.showOnlyActive) {
                query.where('is_active', true);
            }

            if (!this.showOnlyActive && this.showActiveFirst) {
                query.orderBy('is_active', 'desc');
            }

            return query.orderBy('label', 'asc')
                .limit(0)
                .get()
                .then((response) => {
                this.entries = response;
            });
        }
    }
}
</script>
